import { NotifyHelper } from "../../../helpers/toast";
import { eRangBuocActionsObj } from "../../action-types/category/IRangBuocActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const rangBuocActions = {
  ...generateActions(eRangBuocActionsObj, "RANG_BUOC"),
  ...generateActionForKey(
    eRangBuocActionsObj,
    "RANG_BUOC",
    "SAVE_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eRangBuocActionsObj,
    "RANG_BUOC",
    "DELETE_SUCCESS",
    () => {
      NotifyHelper.Success("Thành công");
    }
  ),
  ...generateActionForKey(
    eRangBuocActionsObj,
    "RANG_BUOC",
    "SAVE_ERRR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
  ...generateActionForKey(
    eRangBuocActionsObj,
    "RANG_BUOC",
    "DELETE_ERRR",
    (m) => {
      NotifyHelper.Error(m);
    }
  ),
};
